<script lang="ts" setup>
import { AppSlidePanel } from '@libs/ui';

import TripPriceSummary from '../tripSummary/TripPriceSummary.vue';
import { useTripSummaryStore } from '../../stores';

interface TripPriceSummaryPanelProps {
  isOpen: boolean;
}

const props = defineProps<TripPriceSummaryPanelProps>();

interface TripPriceSummaryPanelEmits {
  (event: 'close'): void;
}

const emit = defineEmits<TripPriceSummaryPanelEmits>();

const tripSummaryStore = useTripSummaryStore();

const onClose = (): void => {
  emit('close');
};
</script>

<template>
  <AppSlidePanel
    direction="right"
    width="33.3%"
    :is-open="props.isOpen"
    should-show-close-button
    :close-button-aria-label="$t('a11y.close_panel')"
    @close="onClose"
  >
    <template #title>{{ $t('planner.price_details') }}</template>
    <template #body>
      <TripPriceSummary :price-segments="tripSummaryStore.tripPriceSegments" />
    </template>
  </AppSlidePanel>
</template>
